<ng-select
	#theSelect
	class="pcg-select"
	[class.d-none]="showNativeSelect == null ? false : showNativeSelect"
	[multiple]="multiple"
	[placeholder]="placeholder ?? ''"
	[labelForId]="labelForId"
	[(ngModel)]="value"
	[items]="items"
	(change)="onChange"
	(touch)="onTouched"
	groupBy="groupBy"
	bindLabel="text"
	bindValue="value"
	[clearable]="clearable"
	[virtualScroll]="virtualScroll"
	[searchable]="!isMobile"
></ng-select>


